import { ArrowDownWideNarrow, ArrowUpNarrowWide } from 'lucide-react'
import { useTranslation } from 'react-i18next'

import { Button } from '@/components/ui/button'
import type { ListSortDir } from '@/lib/listSort'

type SortOrderToggleProps = {
  value: ListSortDir
  onChange: (next: ListSortDir) => void
}

export function SortOrderToggle({ value, onChange }: SortOrderToggleProps) {
  const { t } = useTranslation('common')
  const isDesc = value !== 'asc'

  return (
    <Button
      type="button"
      variant="outline"
      size="sm"
      onClick={() => onChange(isDesc ? 'asc' : 'desc')}
      title={isDesc ? t('listSort.switchToAscending') : t('listSort.switchToDescending')}
    >
      {isDesc ? (
        <ArrowDownWideNarrow className="h-4 w-4 mr-2" />
      ) : (
        <ArrowUpNarrowWide className="h-4 w-4 mr-2" />
      )}
      {isDesc ? t('listSort.descending') : t('listSort.ascending')}
    </Button>
  )
}
